import { useQuery } from 'react-query';
import * as PretaxDependentApi from 'apis/pretaxDependent';

export type IPretaxDependent =
  PretaxDependentApi.FetchDependentsResponse['dependents'][0];

const getPretaxDependents = async () => {
  const {
    data: { dependents },
  } = await PretaxDependentApi.fetchDependents({ statuses: 'New,Active' });
  return { pretax_dependents: dependents };
};

const useQueryPretaxDependents = ({
  is_cdh_enabled,
}: {
  is_cdh_enabled: boolean;
}) => {
  const {
    data,
    isLoading: is_loading,
    refetch,
  } = useQuery(['getPretaxDependents'], () => getPretaxDependents(), {
    enabled: !!is_cdh_enabled,
  });

  return {
    data,
    is_loading,
    refetch,
  };
};

export default useQueryPretaxDependents;
